import React, { useEffect, useState } from "react";
import "./Testimonials.css";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  const SHEET_CSV_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vSgWPyL5Wf7HJluHy8fBzD7PHWp_B_ArdJDh0Y5BcSqpHzcRfjUBLQjZWZ1HQ05gU21oD70gU-KXKl9/pub?output=csv"; // Replace with actual

  useEffect(() => {
    fetch(SHEET_CSV_URL)
      .then((res) => res.text())
      .then((csvText) => {
        const lines = csvText.split("\n").filter((line, index) => index !== 0); // skip header
        const data = lines.map(line => {
          const [ImageURL, Name, Destination, Feedback] = line.split(",");
          return { ImageURL, Name, Destination, Feedback };
        });
        setTestimonials(data);
      })
      .catch(err => console.error("Error loading testimonials:", err));
  }, []);

  return (
    <section className="testimonials-section">
      <h2 className="section-heading">Valuable Feedbacks from our customers</h2>
      <div className="testimonial-slider">
        {testimonials.map((item, index) => (
          <div key={index} className="testimonial-card">
            <img src={item.ImageURL} alt={item.Name} className="testimonial-img" />
            <div className="testimonial-content">
              <h3>{item.Name}</h3>
              <h4>{item.Destination}</h4>
              <p>"{item.Feedback}"</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
